import api from "../api";
import { getJwt } from "@app/helpers";

const controller = '/NaoPrevistoSolicitacao';
const controllerAprovador = '/NaoPrevistoAprovador';


export interface SolicitacaoNaoPrevisto {
    id: string;
    codigo: string;
    CodigoSolicitacaoTexto: string;
    codigoNaoPrevistoTexto: string;
    ano: number;
    tipo: string;
    dataAbertura: string;
    solicitante: string;
    nomeSolicitante: string;
    status: string;
    dataUltimoStatus: string;
    statusId: string;
    stepHash: string;
    recursosParaExecucaoEconomiasEmOutrosProjetos: boolean;
    contratacaoNecessaria: string[];
    observacaoContratacaoNecessaria: string;
    rfa: boolean;
    emergencial: boolean;
    tradeOff: boolean;
    maturidadeEOuNivelDeDefinicao: string[];
    fornecedorDirecionado: boolean;
    fornecedores: string[];
    dataConclusaoDefinicaoDoTipoSolicitacao?: Date;
    dataConclusaoPreenchimentoDaSolicitacao?: Date;
    dataConclusaoVincularAoProjeto?: Date;
    responsavelVincularAoProjeto?: string;
    canDelete: boolean;
    reabrir: boolean;
    reprovador: string,
    justificativaReprovacao: string,
    statusAprovacaoId: string,
    diretoriaResponsavel: string
    areaResponsavel: string
}


export interface SolicitacaoNaoPrevistoFinanceiro {
    id: string;
    impactoNoForecastFinanceiro?: number 
    forecastAtualizadoFinanceiro?: number
}


export interface HistoricoSolicitacaoNaoPrevisto {
    id: string;
    usuarioResponsavel?: string;
    descricao?: string;
    dataHoraFormatada: string;
}

export interface AprovacaoSolicitacaoNaoPrevisto {
    id: string;
    enabled: boolean;
    justificativa: string;
    aprovador: string;
    aprovadorFuncao: string;
    aprovadorDiretoriaAreaDepartamento: string;
    dataAprovacao: string;
    dataAprovacaoFormatada: string;
    statusAprovacaoSolicitacaoNaoPrevistoNome: string;
    statusAprovacaoSolicitacaoNaoPrevistoId: string;
    tipoAprovacaoSolicitacaoNaoPrevistoNome: string;
    tipoAprovacaoSolicitacaoNaoPrevistoId: string;
    appAprovadorId?: string;
    appAprovadorDocumentId?: string;
}

export interface SolicitacaoNaoEnviada {
    solicitacaoId: string;
    codigoSolicitacaoTexto: string;
    nomeProjeto: string;
    solicitante: string;
    statusSolicitacao: string;
    dataUltimoStatusFormatada: string;
    aprovacaoId: string;
    tipoAprovacaoNome: string;
    aprovadorNome: string;
    mensagemErroIntegracao?: string;
}

export interface UsuarioPermissaoSolicitacao {
    podeAprovar: boolean;
    podeAvancar: boolean;
    podeVisualizar: boolean;
    solicitacaoId: string;
}

export interface GetSaldosNaoPrevisto {
    saldoGA: number;
    saldoDR: number;
}

export const getSolicitacaoNaoPrevisto = async (id: string) => {
    return await api.get<SolicitacaoNaoPrevisto>(`${controller}/${id}`);
}

export interface PaginationMeta {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export const listarSolicitacoesNaoPrevisto = async (pageNumber = 1, pageSize = 5) => {
    const token = getJwt();
    const response = await fetch(`/api/NaoPrevistoSolicitacao/listar?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
        headers: {
            'Authorization': token ? `Bearer ${token}` : '',
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Erro ao listar solicitações de não previsto.');
    }

    const body = await response.json() as { items: SolicitacaoNaoPrevisto[]; meta: PaginationMeta };
    const data = Array.isArray(body.items) ? body.items : [];
    const pagination: PaginationMeta | null = body.meta || null;

    return { data, pagination };
}

export const avancarSolicitacaoNaoPrevisto = async (solicitacao: SolicitacaoNaoPrevisto) => {
    return await api.put(`${controller}/avancar`, solicitacao);
}

export const validarSolicitacaoNaoPrevisto = async (id: string, validacao: boolean, justificativa?: string) => {
    return await api.put(`${controller}/validar`, { id, validacao, justificativa });
}

export const updateSolicitacaoNaoPrevisto = async (solicitacao: SolicitacaoNaoPrevisto) => {
    return await api.put(`${controller}/update`, solicitacao, {}, 'false');
}


export const updateSolicitacaoNaoPrevistoFinanceiro = async (solicitacao: SolicitacaoNaoPrevistoFinanceiro) => {
    return await api.put(`${controller}/updateFinanceiro`, solicitacao, {}, 'false');
}


export const deleteSolicitacaoNaoPrevisto = async (id: string) => {
    return await api.delete(`${controller}/${id}`);
}

export const getHistoricoSolicitacaoNaoPrevisto = (id: string) => api.get<HistoricoSolicitacaoNaoPrevisto[]>(`${controller}/GetHistoricoSolicitacaoNaoPrevisto/${id}`);

export const getBalancoEconomico = (id: string) => api.get(`${controller}/GetBalancoEconomico/${id}`);

export const getAprovacoesNaoPrevisto = (id: string) => api.get<AprovacaoSolicitacaoNaoPrevisto[]>(`${controller}/GetAprovacoes/${id}`);

export const syncAppAprovador = (id: string | undefined) => api.get(`${controllerAprovador}/RoutineAprovacoes/${id}`);

export const enviarSolicitacaoAprovador = (aprovacaoId: string) => api.post(`${controllerAprovador}/${aprovacaoId}`);

export const getSolicitacoesNaoEnviadas = () => api.get<SolicitacaoNaoEnviada[]>(`${controller}/NaoEnviadas`);

export const getUsuarioPermissaoSolicitacao = (id: string) => api.get<any>(`${controller}/GetUsuarioPermissaoSolicitacao/${id}`);

export const reabrirSolicitacaoNaoPrevisto = async (id: string) => await api.put(`${controller}/reabrir`, { id });
export const encerrarSolicitacaoNaoPrevisto = async (id: string) => await api.put(`${controller}/encerrar`, { id });

export const getSaldosNaoPrevisto = (responsavelArea: string,  responsavelDiretoria: string, tipo: string) => api.get<GetSaldosNaoPrevisto>(`${controller}/GetSaldosSolicitacaoNaoPrevisto`, { responsavelArea, responsavelDiretoria, tipo });
